import type { ProductsByCategoriesQuery } from "@chef/state-management";
import type { StandaloneBasketVariant } from "@chef/types/basket";

import { StandaloneProductTile } from "./StandaloneProductTile";

type ProductsFromCategoriesCardGridProps = {
  products: ProductsByCategoriesQuery["productsByCategories"][number]["products"];
  categoryId: ProductsByCategoriesQuery["productsByCategories"][number]["productCategoryId"];
  week: number;
  year: number;
  view: "deviation";
  basketType: StandaloneBasketVariant;
};

export const ProductsFromCategoriesCardGrid = ({
  week,
  year,
  products = [],
  categoryId,
  basketType,
  view,
}: ProductsFromCategoriesCardGridProps) => {
  return (
    <div
      id={categoryId}
      className="grid items-start grid-cols-2 gap-3 mt-4 mb-8 md:gap-4 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6"
    >
      {products.map((product, index) => {
        const { variations = [] } = product;
        const isPrioritisedProduct = index < 6;

        return variations.map((variation) => {
          return (
            <StandaloneProductTile
              key={variation.variationId}
              view={view}
              basketType={basketType}
              productId={product.productId}
              variationId={variation.variationId}
              isPrioritisedProduct={isPrioritisedProduct}
              week={week}
              year={year}
            />
          );
        });
      })}
    </div>
  );
};
